var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"d-flex justify-content-center align-item-center",attrs:{"cols":"12"}}),_c('b-col',[[(_vm.currentPage==1)?_c('page1',{on:{"next":function($event){return _vm.next($event)},"back":function($event){return _vm.next($event)}}}):_vm._e()]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }